import Image from 'next/image';
import React from 'react';

import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { Highlight } from '@/components/squeeze';

import agencySpeechBubble from './images/agency-speech-bubble.png';

export const SpeechHighlight: React.FC<{
  speakerImage?: React.ReactNode;
  children: React.ReactNode;
}> = ({ speakerImage, children }) => {
  const { brand } = useFlowContext();

  {
    /* TODO: Remove optional prop and Highlight when we have Curology speaker asset */
  }
  if (!speakerImage) {
    return <Highlight>{children}</Highlight>;
  }
  return (
    <div className="cur-flex cur-gap-5">
      <div className="cur-min-w-fit">{speakerImage}</div>
      <div className="cur-relative">
        {/* TODO: Remove conditional when we have a speech bubble asset for Curology brand highlight */}
        {brand === 'agency' && (
          <Image
            src={agencySpeechBubble}
            alt="Speech bubble"
            width="12"
            height="10"
            className="cur-absolute cur-top-4 -cur-left-3"
          />
        )}
        <div className="cur-flex cur-flex-col cur-gap-4 cur-px-4 cur-py-3 cur-bg-surface-highlight-hover cur-rounded-2xl">
          {children}
        </div>
      </div>
    </div>
  );
};
